$( document ).ready(function() {
    var modelError = $('.error-model')
    var chkColor = $('.csbundle:checked').val()
    $('#colorBundle').val(chkColor)
    $('.bundcolor .cont').text(chkColor)


    $('.csbundle').click( function() {
        var id = $(this).data('sel')
        var parent = $(this).parents('.bundcolor')
        var ind = $(parent).find('span.cont')
        var data = $(this).val() 
        $(ind).text(data) 

        $(modelError).hide()
        $(this).removeClass('red')
        $('#colorBundle').val('')
        $('#modelBundle').val('')

         var index = $(`.Carousel__Cell[data-varimg="${data}"]`).data('media-position')
        
        var flkty = new Flickity('.Product__Slideshow');
        flkty.select( index - 1 );

        if ($(window).width() > 1008 ) {
            var el = $('.Product__Slideshow').find(`[data-varimg=${data}]`)
            if (el.length) {
                $('html, body').animate({
                    scrollTop: $(el).offset().top
                }, 500);
            }

        }


        // $('.Product__Gallery').hide()
        $('.selecTor').hide()
        $(`.selecTor[data-sel="${id}"]`).show()
        parent.find('.ProductForm__Label').removeClass('red')

        $(`.selecTor[data-sel="${id}"]`).find('.bund-sel option').show()

        var prodID = $(`.selecTor[data-sel="${id}"]`).find('.bund-sel option:selected').data('productid')
        var varId = $(`.selecTor[data-sel="${id}"]`).find('.bund-sel option:selected').data('var')
        var varName = $(`.selecTor[data-sel="${id}"]`).find('.bund-sel option:selected').text()

        
        $("#selItems").val(varName + ' - ' +  data)
        $('#colorBundle').val(prodID)
        $('#modelBundle').val(varId)

        // $(`.Product__Gallery[data-sel="${id}"]`).show()

        if ( !$('#colorBundle').val() == "" ) {
            $('.bundcolor span.ProductForm__Label').removeClass('red')
            $('.bundle-add').removeAttr('disabled')
        }
        // var $carousel = $('.Product__Slideshow')
        // $carousel.flickity('resize')
    })

    if ($('.bund-sel option:checked').length > 0 ) {
        var activeColor = $('.csbundle:checked').data('sel')
        var activeColorName = $('.csbundle:checked').val()
        var index = $(this).parents('.selecTor')
        var index = $(index).data('sel')
        var modelValue = $(`.selecTor[data-sel="${activeColor}"]`).find('.bund-sel option:checked')
        var inActives = $('.selecTor').not(`.selecTor[data-sel="${activeColor}"]`)
        var unCheckeds = $(inActives).find('.bund-sel option:checked')

        var varName = $(`.selecTor[data-sel="${activeColor}"]`).find('.bund-sel option:selected').text()
            
        $(unCheckeds).attr('checked', false)
        $('.bund-sel option:checked').attr('checked', false)
        $('#modelBundle').val($(modelValue).data('var'))
        
        $("#selItems").val(varName + ' - ' + activeColorName)
    }
    $('.bund-sel').on('change', function() {
        var prodID = $(this).find(":selected").data('productid')
        var id = $(this).find(":selected").data('var')
        var parent = $(this).parents('.bundmodel')
        var data = $(this).val()
        var colorName = $('.csbundle:checked').val()

        $('#colorBundle').val('')
        $('#modelBundle').val('')

        $("#selItems").val(data + ' - ' +  colorName)
        $('#colorBundle').val(prodID)
        $('#modelBundle').val(id)

        if ( !$('#modelBundle').val() == "" ) {
            $(modelError).hide()
            $('.bundle-add').removeAttr('disabled')
        }

        if ($(this).val() != "") {
            $(this).parents('.selecTor').addClass('right-arr')
        } else {
            $(this).parents('.selecTor').removeClass('right-arr')
        }
        if ( data == null ) {
            modelError.show()   
            // $('.bundcolor .ProductForm__Label').addClass('red')
            $(this).find('option').show()
            $(this).addClass('red')
            $(this).parents('.selecTor').addClass('redded')
        } else {
            modelError.hide()
            $(this).find('option').show()
            $(this).removeClass('red')
            $(this).parents('.selecTor').removeClass('redded')
        }
    })
    

    var csinput = $('input[data-sel="0"]:checked')
    
    if ( $('input[data-sel="0"]:checked').length > 0 ) {
        $('.selecTor[data-sel="0"]').show()
    }

    var csbundle = $('.csbundle:checked').data('sel')
    $(`.selecTor[data-sel="${csbundle}"]`).show()

    $('select.filt-sel').on('change', function() {
        $(this).parents('.filt-wrapper').addClass('right-arr')
        window.location.href = $(this).val()
    })
    
    $('.selecTor').on('change', function() {
		$('.ProductForm__AddToCart').removeClass('Button--secondary')
        $('.ProductForm__AddToCart').addClass('Button--primary')
        $('.ProductForm__AddToCart').text('הוסיפי לסל')
    })
});



